module.exports = __webpack_public_path__ + "img/32.940c37b5.jpg";